export const SavedElementTypes = {
  Linked: 'SavedElementContents::Linked',
  Template: 'SavedElementContents::Template',
};
